/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
export const Favorites = () => (
  <div className="sectionHb-block review invites">
    <div className="sectionHb-block__wrap">
      <div className="favorites-top">
        <div className="row">
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="input-block">
              <div className="select">
                <div className="select-top">
                  <span className="select-text">This week</span>
                </div>
                <div className="select-info">
                  <ul>
                    <li>
                      <a href="#">Teacher</a>
                    </li>
                    <li>
                      <a href="#">Child</a>
                    </li>
                    <li>
                      <a href="#">Parents</a>
                    </li>
                  </ul>
                </div>
                <input type="text" className="select-value" />
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="input-block">
              <div className="select">
                <div className="select-top">
                  <span className="select-text">All</span>
                </div>
                <div className="select-info">
                  <ul>
                    <li>
                      <a href="#">Teacher</a>
                    </li>
                    <li>
                      <a href="#">Child</a>
                    </li>
                    <li>
                      <a href="#">Parents</a>
                    </li>
                  </ul>
                </div>
                <input type="text" className="select-value" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="favorites-list">
        <div className="favorites-item">
          <a href="#" className="favorites-img">
            <img src="img/purchaseHb-min.jpg" alt="" />
          </a>
          <div className="favorites-info">
            <h3 className="favorites-title">
              Name 1234
              <a href="#">by Kate Bee</a>
            </h3>
            <div className="favorites-text">
              <span>File Type:</span>
              PDF (32 MB) 16 pages
            </div>
            <span className="favorites-date">5h ago</span>
          </div>
          <div className="favorites-actions">
            <ul>
              <li>
                <a href="#" className="hb-ico basket-ico" />
              </li>
              <li>
                <a href="#" className="hb-ico favorite-ico" />
              </li>
            </ul>
            <a href="#" className="favorites-btn">
              Printables
            </a>
          </div>
        </div>
        <div className="favorites-item">
          <a href="#" className="favorites-img">
            <img src="img/purchaseHb-min.jpg" alt="" />
          </a>
          <div className="favorites-info">
            <h3 className="favorites-title">
              Name 1234
              <a href="#">by Kate Bee</a>
            </h3>
            <div className="favorites-text">
              <span>File Type:</span>
              PDF (32 MB) 16 pages
            </div>
            <span className="favorites-date">5h ago</span>
          </div>
          <div className="favorites-actions">
            <ul>
              <li>
                <a href="#" className="hb-ico play-ico" />
              </li>
              <li>
                <a href="#" className="hb-ico favorite-ico" />
              </li>
            </ul>
            <a href="#" className="favorites-btn lessons">
              Lessons
            </a>
          </div>
        </div>
        <div className="favorites-item">
          <a href="#" className="favorites-img">
            <img src="img/purchaseHb-min.jpg" alt="" />
          </a>
          <div className="favorites-info">
            <h3 className="favorites-title">
              Name 1234
              <a href="#">by Kate Bee</a>
            </h3>
            <div className="favorites-text">
              <span>File Type:</span>
              PDF (32 MB) 16 pages
            </div>
            <span className="favorites-date">5h ago</span>
          </div>
          <div className="favorites-actions">
            <ul>
              <li>
                <a href="#" className="hb-ico data-ico" />
              </li>
              <li>
                <a href="#" className="hb-ico favorite-ico" />
              </li>
            </ul>
            <a href="#" className="favorites-btn teacher">
              Teacher
            </a>
          </div>
        </div>
        <div className="favorites-item">
          <a href="#" className="favorites-img">
            <img src="img/purchaseHb-min.jpg" alt="" />
          </a>
          <div className="favorites-info">
            <h3 className="favorites-title">
              Name 1234
              <a href="#">by Kate Bee</a>
            </h3>
            <div className="favorites-text">
              <span>File Type:</span>
              PDF (32 MB) 16 pages
            </div>
            <span className="favorites-date">5h ago</span>
          </div>
          <div className="favorites-actions">
            <ul>
              <li>
                <a href="#" className="hb-ico print-ico">&nbsp;</a>
              </li>
              <li>
                <a href="#" className="hb-ico favorite-ico">&nbsp;</a>
              </li>
            </ul>
            <a href="#" className="favorites-btn">
              Printables
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
)
